<template>
  <v-container class="py-10 py-md-13 py-lg-16 item">
    <TitleWidget>
      {{ item.title }}
    </TitleWidget>

    <v-row class="mt-6 mt-md-8" justify="center" no-gutters>
      <v-col cols="12" md="9">
        <img
          v-if="image"
          @error="onError"
          class="d-block"
          loading="lazy"
          :src="image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
          :alt="item.title"
          width="100%"
        />

        <div
          v-if="item.text"
          class="
            grey--text
            text--darken-2 text-subtitle-1
            font-weight-light
            mt-6 mt-md-8
            item-text
            ck-content
          "
        >
          <span class="font-secondary" v-html="item.text"></span>
        </div>

        <div v-if="images.length > 1" class="grid-list mt-6 mt-md-8">
          <template v-for="({ thumb }, keyImages) in images">
            <img
              :key="keyImages"
              @click="showGallery(keyImages)"
              class="d-block cursor-pointer"
              :src="thumb"
              width="100%"
            />
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "events",
};

const _data = {
  title: "Eventos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      if (this.item?.img?.featured?.path)
        return this.files + this.item.img.featured.path;

      return "";
    },
    images() {
      if (this.item?.img?.list)
        return this.item.img.list.map(({ path }) => ({
          src: this.files + path + "?resize=1&w=1200",
          thumb: this.files + path + "?resize=1&w=400",
        }));

      return [];
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getItem() {
      this.loading = true;

      this.$rest(_config.mod).get({
        id: this.itemId,
        save: (state, data) => (state.item = data),
      });
    },
    showGallery(index) {
      window.showGalleryWidget(this.images, index);
    },
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
  watch: {
    $route() {
      this.getItem();
    },
  },
  created() {
    this.getItem();
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }
}

.grid-list {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 959.9px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr 1fr;
  }

  img {
    aspect-ratio: 4 / 3;
    object-fit: cover;
  }
}
</style>
